import UUIDBase from '../UUIDBase'
import Customer from './Customer'
import Task from '@/models/hr/Task'

export const documentationI18nMessages = {
  en: {
    documentation: 'Notes',
    documentationHistory: 'Notes History',
    newDocumentation: 'New Note',
    documentationNumber: 'Note No',
    name: 'Customer Name',
    phone: 'Phone',
    contactVia: 'Contact Via',
    subject: 'Subject',
    note: 'Note',
    phoneCall: 'Phone Call',
    message: 'Message',
    inPerson: 'In Person',
    addedBy: 'Added By',
    relatedTask: 'Related Task',
    addTask: '+ Add Task',
    taskExternalID: 'Task No',
    taskDueDate: 'Task Due Date',
    taskStatus: 'Task Status',
    toDo: 'To Do',
    inProgress: 'In Progress',
    done: 'Done',
    canceled: 'Canceled',
  },
  ar: {
    documentation: 'الملاحظات',
    documentationHistory: 'سجل الملاحظات',
    newDocumentation: 'ملاحظة جديدة',
    documentationNumber: 'رقم الملاحظة',
    name: 'اسم الزبون',
    phone: 'الهاتف',
    contactVia: 'طريقة التواصل',
    subject: 'الموضوع',
    note: 'الملاحظات',
    phoneCall: 'مكالمة هاتفية',
    message: 'رسالة',
    inPerson: 'شخصياً',
    addedBy: 'أضيف بواسطة',
    relatedTask: 'المهمة المرتبطة',
    addTask: '+ إضافة مهمة',
    taskExternalID: 'رقم المهمة',
    taskDueDate: 'تاريخ استحقاق المهمة',
    taskStatus: 'حالة المهمة',
    toDo: 'للتنفيذ',
    inProgress: 'قيد التنفيذ',
    done: 'منفَّذة',
    canceled: 'ملغيّة',
  }
}

export interface DocumentationPaginated {
  data: Array<Documentation>,
  total: number
}

export default class Documentation extends UUIDBase {
  static from(json: Record<string, unknown> | Documentation) {
    return Object.assign(new Documentation(), json)
  }
  static ENDPOINT = '/customer/notes'

  name = ''
  phone = ''
  contactVia = ''
  subject = ''
  note = ''
  customerID: string | null = null
  customer: Customer | undefined
  vendorID: string | null = null
  isStarred: boolean = false
  userID: string | null = null
  user: any = undefined
  task: Task | null = null
  pendingTaskID = ''
}
